import React, { memo, useCallback, useMemo } from 'react';
import { ISuggestion } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { AttributeValueSizeType } from '../../../../../../Components/Attributes/AttributeValue/AttributeValue';
import { AssociationHeader } from '../AssociationHeader/AssociationHeader';
import { EDAutoCompleteEdit } from '../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import { CommonPropsAndTypes } from '../../../../../../BaseComponents/_Types/StandardComponentProps';

export interface IAssociationChoiceProps
  extends CommonPropsAndTypes.IMarginProps {
  value?: string;
  label: string;
  onAssociationSelected: (suggestion: ISuggestion | null) => void;
  size?: AttributeValueSizeType;
  relativeSize?: boolean;
  editMode?: boolean;
  noMargin?: boolean;
  required?: boolean;
  requiredMessage?: string;
  placeHolder?: string;
  marker?: boolean;
  inGrid?: boolean;
  tooltip?: string | null;
  disabled?: boolean;
  errorMessage?: string;
  warningMessage?: string;
  hintMessage?: string;
  fullWidth?: boolean;
  hideLabel?: boolean;
  hideOutline?: boolean;
  topMargin?: CommonPropsAndTypes.StandardSpacingType;
  disableArrowIcon?: boolean;
  inputMargin?: 'dense' | 'none' | 'normal';
  lineMarker?: boolean;
  disableDisabledBackgroundColor?: boolean;
  inputRef?: React.MutableRefObject<HTMLInputElement | undefined>;
  testId?: string;
  onBlur?: (
    event: React.FocusEvent<HTMLInputElement | HTMLDivElement, Element>
  ) => void;
  onFocus?: (event: React.FocusEvent<HTMLElement, Element>) => void;
  disableTabbing?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

interface IProps extends IAssociationChoiceProps {
  options: ISuggestion[];
}

const BaseAssociationAutocomplete: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const choice = useMemo(
    () =>
      props.value
        ? props.options.find(x => x.value === props.value) ?? null
        : null,
    [props.value, props.options]
  );

  const getOptionLabel = useCallback(
    (option: { name: string }) => option.name,
    []
  );
  return (
    <>
      {props.editMode && (
        <EDAutoCompleteEdit
          label={props.label}
          value={choice}
          options={props.options}
          getOptionLabel={getOptionLabel}
          onChange={props.onAssociationSelected}
          fullWidth={props.fullWidth}
          size={props.size}
          required={props.required}
          requiredMessage={props.requiredMessage}
          placeholder={props.placeHolder}
          disableOpenOnFocus
          marker={props.marker}
          tooltip={props.tooltip}
          disabled={props.disabled}
          errorMessage={props.errorMessage}
          warningMessage={props.warningMessage}
          hintMessage={props.hintMessage}
          hideLabel={props.hideLabel}
          hideOutline={props.hideOutline}
          inputMargin={props.inputMargin}
          disableArrowIcon={props.disableArrowIcon}
          lineMarker={props.lineMarker}
          disableDisabledBackgroundColor={props.disableDisabledBackgroundColor}
          inputRef={props.inputRef}
          testId={props.testId}
          onBlur={props.onBlur}
          onFocus={props.onFocus}
          disableTabbing={props.disableTabbing}
          setOpen={props.setOpen}
        />
      )}
      {!props.editMode && (
        <AssociationHeader displayLabel={props.label} value={props.value} />
      )}
    </>
  );
};

export const AssociationAutocomplete: React.FC<
  React.PropsWithChildren<IProps>
> = memo(props => {
  return <BaseAssociationAutocomplete {...props} />;
});
